export default __webpack_public_path__ + "static/media/beetle2.29609351.jpg";